import { RunStatusDto, useGetRunGroupsByBaseGraphQuery } from "@store/services/runService"

export const useHasValidRunsForGraph = (graphKey: string | undefined) => {
  const { data, isLoading } = useGetRunGroupsByBaseGraphQuery(graphKey ?? "", {
    skip: !graphKey,
  })

  const hasValidRuns =
    data?.items?.some((item) =>
      Object.values(item.runs).some((run) => run.status === RunStatusDto.DONE),
    ) ?? false

  return { isLoading, hasValidRuns }
}
